<div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
  <new-ui-multiselect
    [dt]="props.dt"
    [formControl]="$any(formControl)"
    [formlyAttributes]="field"
    [options]="
      props.group
        ? (props.options | groupItems: props.staticDataType | async)
        : (props.options | formlySelectOptions: field | async)
    "
    [group]="props.group"
    [optionLabel]="props.optionLabel ?? 'label'"
    [optionValue]="props.optionValue ?? 'value'"
    [optionGroupChildren]="props.optionGroupChildren ?? 'group'"
    [label]="props.label"
    [showClear]="!props.readonly"
    [required]="props.required"
    [readonly]="props.readonly"
    [showToggleAll]="props.showToggleAll"
    [maxSelectedLabels]="props.maxSelectedLabels"
    [display]="props.display"
    [badgeDisabled]="props.badgeDisabled"
    [isVertical]="props.isVertical"
    [showCommaSepartedInReadOnly]="props.showCommaSepartedInReadOnly"
    [truncateOutput]="props.truncateOutput"
  />

  @if (!props.readonly && props.hint) {
    <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
      {{ props.hint }}
    </p-message>
  }

  @if (showError) {
    <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
      <formly-validation-message [field]="field" />
    </p-message>
  }
</div>
